// extracted by mini-css-extract-plugin
export default {"drawerHeader":"Chatbot_drawerHeader__iM+Qo","drawerBody":"Chatbot_drawerBody__zTt9l"};